import { Flex } from '@chakra-ui/react';
import { callMemberPointCardInquiry } from 'features/smart-receipt/api';
import { LINK_PAGE_PATH } from 'features/smart-receipt/pages';
import { openWindow } from 'libs/line';
import { tenantConfigurationAtom } from 'libs/recoil/atom';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

export const TopBanner: FC = () => {
  const tenantConfig = useRecoilValue(tenantConfigurationAtom);
  const navigate = useNavigate();
  const [isLinkedMember, setLinkedMember] = useState<boolean | null>(null);
  const [isDisplayed, setDisplayed] = useState<boolean>(false);

  useEffect(() => {
    if (!tenantConfig.smart_receipt?.enabled) {
      return;
    }
    (async () => {
      try {
        const isLinkedMember = await callMemberPointCardInquiry();
        setLinkedMember(isLinkedMember);
        setDisplayed(true);
      } catch (error) {
        console.error(error);
        setDisplayed(false);
      }
    })();
  }, [tenantConfig.smart_receipt?.enabled]);

  // スマレシ設定が無効、もしくはスマレシAPIの問い合わせに失敗した場合、スマレシバナーは表示しない
  // NOTE: PMと相談して、ロイヤルHCと同じ仕様にしている
  if (!tenantConfig.smart_receipt?.enabled || !isDisplayed) {
    return null;
  }

  const smartReceiptSetting = tenantConfig.smart_receipt;

  const handleClick = () => {
    if (isLinkedMember) {
      // LIFFブラウザの場合、liff.openWindowを使わないと外部URLを正しく開けない
      openWindow(smartReceiptSetting.login_url);
    } else {
      navigate(LINK_PAGE_PATH);
    }
  };

  const getBannerImageUrl = () => {
    if (isLinkedMember) {
      return smartReceiptSetting.linked_image;
    } else {
      return smartReceiptSetting.non_link_image;
    }
  };

  const getBannerImageAlt = () => {
    if (isLinkedMember) {
      return 'スマートレシートの確認';
    } else {
      return 'スマートレシート連携';
    }
  };

  return (
    <Flex
      margin="1rem"
      gap="2"
      direction="column"
      alignItems="center"
      onClick={handleClick}
    >
      <img
        src={getBannerImageUrl()}
        alt={getBannerImageAlt()}
        style={{
          maxWidth: '100%',
          height: 'auto'
        }}
        data-testid="smart-receipt-banner"
      />
    </Flex>
  );
};
